import React, { useEffect, useState } from "react";
import { BrowserRouter } from "react-router-dom";
import SideMenu from "../components/organisms/SideMenu/SideMenu";
import { MenuProvider } from "../context/MenuContext";
import { desEncriptar, encriptar } from "../utilidades/encriptacion";
import GuestRoutes from "./GuestRoutes/GuestRoutes";
import AuthRoutes from "./AuthRoutes/AuthRoutes";
import "primereact/resources/themes/lara-light-cyan/theme.css";
import Bienestar from "./AuthRoutes/Bienestar/Bienestar";

const MainRouter = () => {
    const [auth, setAuth] = useState(false);
    const [showBienestar, setShowBienestar] = useState(false);

    useEffect(() => {
        const clave = process.env.REACT_APP_CLAVE_INCRIPTACION;
        if (sessionStorage.getItem('auth')) {
            const autLocal = sessionStorage.getItem('auth');

            if (desEncriptar(autLocal, clave) === "false") {
                setAuth(false);
            }
            else {
                setAuth(true);
            }
        }
        else {
            sessionStorage.setItem('auth', encriptar(`${auth}`, clave));
        }
    }, [auth]);

    return (
        <BrowserRouter>
            {
                auth ? (
                        <MenuProvider>
                            <SideMenu setAuth={setAuth} setShowBienestar={setShowBienestar}>
                                <AuthRoutes></AuthRoutes>
                            </SideMenu>
                        </MenuProvider>
                    )
                : (
                    <GuestRoutes></GuestRoutes>
                )
            }
        </BrowserRouter>
    );
};

export default MainRouter;